/**
 * Created by jonas on 2022-06-15.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTHGameConfig} from "../HTHGameConfig";
import {HTHSymbol} from "../symbols/HTHSymbol";
import {HTH} from "../HTH";
import {HTHEnhancerSymbol} from "../symbols/HTHEnhancerSymbol";
import {HTHSafeSymbol} from "../symbols/HTHSafeSymbol";




export class SanityCheckPresentation implements SimplePresentation {
    public static run: boolean = false;

    constructor() {
    }

    public static checkFinalSymbolSizes(symbolSizes: number[][],reelsAfterAvalanche:string[][], calledFromWhichClass: string): void {
        for (let reelIdx: number = 0; reelIdx < HTHGameConfig.reelsNum; reelIdx++) {
            let num=0;
            for (let symIdx: number = 0; symIdx < 4; symIdx++) {
                if(reelsAfterAvalanche[reelIdx][symIdx]==="AV"){
                    num++;
                    continue;
                }
                const sym: HTHSymbol = HTH.reelArea.getSymbol([reelIdx, symIdx-num]),
                    size: number = symbolSizes[reelIdx][symIdx],
                    returnedSize: number =sym.name==="EB" ? ((<HTHEnhancerSymbol>sym).revealedSymSize===0?1:(<HTHEnhancerSymbol>sym).revealedSymSize) : sym.name ==="SA" ? ((<HTHSafeSymbol>sym).safeSymSize===0?1:(<HTHSafeSymbol>sym).safeSymSize) :sym.symSize;
                if((sym.symName==="SA" && (<HTHSafeSymbol>sym).revealedSymName==="XN") || (sym.symName==="EB" && (<HTHEnhancerSymbol>sym).revealedSymName==="XN") || sym.symName==="XN"){
                    continue;
                }
                if (returnedSize !== size && !sym.isRemoved ) {
                    debugger
                }
            }
        }
    }

    public static checkSymbolNames(reelsAfterAvalanche:string[][]):void{
        for(let reelIdx: number = 0; reelIdx < HTHGameConfig.reelsNum;reelIdx++) {
            let num=0;
            for(let symIdx: number = 0; symIdx < 4; symIdx++) {
                if(reelsAfterAvalanche[reelIdx][symIdx]==="AV"){
                    num++;
                    continue;
                }
                const sym: HTHSymbol = HTH.reelArea.getSymbol([reelIdx, symIdx-num]);
                let symName:string =reelsAfterAvalanche[reelIdx][symIdx];
                let returnedSymName:string=sym.name;
                if(returnedSymName==="SA"){
                    const safeData=HTH.model.data.safeSymbols;
                    let safeFound:boolean = false;
                    for(let i=0;i<safeData.length;i++){
                        if(safeData[i].x===reelIdx || safeData[i].y===symIdx){
                            safeFound=true;
                        }
                    }
                    if(!safeFound){
                        debugger;
                    }
                    if((<HTHSafeSymbol>sym).isSafeFilled){
                        returnedSymName=(<HTHSafeSymbol>sym).revealedSymName;
                    }
                }
                else if(returnedSymName==="EB"){
                    if((<HTHEnhancerSymbol>sym).isEBFilled){
                        returnedSymName=(<HTHEnhancerSymbol>sym).revealedSymName;
                    }
                }
                else if(returnedSymName==="BL"){
                    returnedSymName="XN";
                }
                if(symName!==returnedSymName){
                    debugger;
                }
            }

        }
    }
    shouldRun(): boolean {
        return SanityCheckPresentation.run && !((HTH.model.gameData.serverTestInfo?.OverrideFlag!)==="LastFreespin");
    }

    start(controller: SimplePresentationRunnerController): void {
        SanityCheckPresentation.checkFinalSymbolSizes(HTH.model.gameData.sizesAfterAvalanche,HTH.model.gameData.reelsAfterAvalanche, "SanityCheckPresentation");
        SanityCheckPresentation.checkSymbolNames(HTH.model.gameData.reelsAfterAvalanche);
        controller.finish();
    }


}